export const THRESHOLD_ADDITIONAL_HEIGHT = 8;

export const METER_BAR_CHART_ARIA_LABEL = 'Meter Bar Chart';
export const METER_BAR_CHART_PLOT_ARIA_LABEL = 'Chart Plot Area';
